<template>
<!--    <div v-html="content"></div>-->
    <div class="disclaimer-box" style="display: flex;flex-direction: column;align-items: center;margin-bottom: 2rem;">
        <div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: #B62D2E;">{{ $t('other.disclaimer') }}</div>
        <div style="display: flex;margin-top:0.5rem;margin-bottom:5rem;">
            <span style="width: 1rem;height: 1rem;background:#B62D2E;border-radius: 50%;margin:0 0.5rem;"></span>
            <span style="width: 1rem;height: 1rem;background:#DE5934;border-radius: 50%;margin:0 0.5rem;"></span>
            <span style="width: 1rem;height: 1rem;background:#F1AA55;border-radius: 50%;margin:0 0.5rem;"></span>
        </div>
        <div class="col-xs-22 col-sm-13" style="word-wrap: break-word;">
          <p>本服務條款是您與數學思維教育有限公司（下稱「我們」、「我們的」或「MathConcept」）關於使用 MathConcept Online 的協議。 本條款及細則說明您在申請和使用 MathConcept Online 時，我們須向您承擔的義務，以及您須向我們承擔的義務。</p><p><strong>費用及付款</strong></p><p>我們的產品均以港元（HKD）計算。</p><p><strong>訂閱及退款</strong></p><p>· 所有已訂閱的計劃均不設退款</p><p><strong>個人資料收集聲明</strong></p><p>當您注冊帳號時，我們需要您提供您及您的子女或受您監護的兒童的個人資料，包括姓名、電郵地址、聯絡號碼等。 倘若我們取得的個人資料不完整或有錯誤，我們可能無法為您和您的子女或受您監護的兒童提供服務。 我們所收集之資料將用作以下用途：</p><p>i. 辦理我們的服務申請；</p><p>ii. 向您及您的子女或受您監護的兒童提供我們的服務；</p><p>iii. 在您同意的情況下，我們會使用您所提供的個人資料，以作市場營銷、推廣及顧客關系管理之用途（只限教育範疇）。我們會以電話、SMS、電郵、電子訊息、傳真、郵件及社交媒體等方式向您提供有關資訊。</p><p>您可以隨時查閱及改正我們持有您的個人資料，如您希望查閱或改正您所提供的資料，請電郵至 <u><a href="mailto:support@mathconceptonline.com">support@mathconceptonline.com</a></u>通知我們。 除非適用的法律另有要求，否則修改是不能即時生效的。我們將盡力在合理可行的情況下盡快滿足您的要求， 但在任何情況下，我們將在不多於我們收到您的要求後的30天內滿足這些要求。</p><p><strong>知識產權</strong></p><p>我們的網站上所有內容、設計、圖像、文字、商標及其他材料的知識產權均由MathConcept擁有。我們嚴禁任何未經事前書面批准的使用。</p><p><strong>彌償</strong></p><p>你同意就因違反本條款及細則而引致我們及我們的所有董事、雇員及第三方作出任何索償、損失、損害、費用、開支（包括法律開支）或其他責任向我們及我們的所有董事、雇員及第三方作出彌償，並使我們免受損害。</p><p><strong>修訂</strong></p><p>我們有權在沒有預先通知的情況下修訂本細則及條款。</p><p><strong>法律管轄權</strong></p><p>本條款及細則是根據香港特別行政區法律所規管及闡釋。</p><p> </p><p><strong>聯絡資料</strong></p><p><strong><em>MathConcept Education Limited</em></strong></p><p><em>地址：九龍荔枝角長沙灣道918號維特健靈中心15樓</em></p><p><em>電郵：</em> <u><a href="mailto:support@mathconceptonline.com">support@mathconceptonline.com</a></u></p><p><em>網站：<u><a href="https://testingapi.mathconceptonline.com">https://testingapi.mathconceptonline.com</a></u></em></p>
        </div>
      <br><br><br><br><br>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            content: ""
        };
    },
    watch: {

    },
    created() {
        
    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
/*.disclaimer-box{
    margin:0 22vw;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .disclaimer-box{
        margin:0 1.25rem 2rem;
    }
}*/
</style>